import {AdminOrderPaymentType, AdminOrderStatusType, AdminOrderType} from '../../gen/api/models';

export function orderTypeLabel(status: AdminOrderType): string {
    switch (status) {
        case AdminOrderType.OrderTypeCustomer:
            return 'Customer Order';
        case AdminOrderType.OrderTypeMarketplace:
            return 'Marketplace Order';
        case AdminOrderType.OrderTypeSelfSale:
            return 'Self Sale Order';
    }
}

export function orderStatusBadge(status: AdminOrderStatusType): string {
    switch (status) {
        case AdminOrderStatusType.OrderStatusCreated:
            return 'grey';
        case AdminOrderStatusType.OrderStatusPaid:
            return 'green';
        case AdminOrderStatusType.OrderStatusCanceled:
            return 'red';
        case AdminOrderStatusType.OrderStatusReturned:
            return 'orange';
    }
}

export function orderPaymentTypeLabel(status: AdminOrderPaymentType): string {
    switch (status) {
        case AdminOrderPaymentType.OrderPaymentTypeCash:
            return 'Cash';
        case AdminOrderPaymentType.OrderPaymentTypeZelle:
            return 'Zelle';
        case AdminOrderPaymentType.OrderPaymentTypePaypal:
            return 'PayPal';
        case AdminOrderPaymentType.OrderPaymentTypeVenmo:
            return 'Venmo';
        case AdminOrderPaymentType.OrderPaymentTypeMarketplace:
            return 'Marketplace';
    }
}
